import React from "react";
// import { TypeAnimation } from "react-type-animation";
import Typewriter from "typewriter-effect";
import resume from "../../assets/resume.pdf";
import { BiArrowToRight } from "react-icons/bi";
import hero1 from "../../assets/hero1.jpg"

const Home = () => {

    return (
        <div className="h-full flex items-center justify-center">
            <div>
                <div className="mx-auto bg-gradient-to-b rounded-full w-40 h-40 overflow-hidden">
                    <img src={hero1} alt="" />
                </div>
                {/* <h1 className="uppercase text text-center text-2xl sm:text-3xl md:text-4xl font-extrabold">
                    I'm Nabil Ahmed Nahid✌️
                </h1> */}
                <h1 className="uppercase mt-4 text-2xl sm:text-3xl md:text-4xl font-extrabold dark:text-[#E9F8F9]">
                    I'm Nabil Ahmed Nahid✌️
                </h1>

                <div className="mt-4 text-lg font-semibold text-gray-500 text-center">
                    <Typewriter
                        options={{
                            strings: [
                                "Front-End Developer ",
                                "React Developer",
                                "WordPress Developer",
                                "MERN Stack Web Developer",
                            ],
                            autoStart: true,
                            loop: true,
                            deleteSpeed: 70,
                            cursor: "_",
                        }}
                    />
                </div>

                {/* <h2 className="w-2/5">
                    A Full Stack Developer who loves solving problems and
                    building projects. I am equipped with a variety of
                    technologies and tools to help me build the best possible
                    product.
                </h2> */}
                <div className="mt-4">
                    <button className="group text-white w-fit px-8 py-3  mx-auto flex items-center rounded-md bg-gradient-to-r from-[#7286D3] to-[#8EA7E9] cursor-pointer">
                        <a href={resume}>Resume</a>
                        <span className="group-hover:rotate-90 duration-300">
                            {" "}
                            <BiArrowToRight size={25} />{" "}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Home;
